import TC from "@/components/table/Table.module.css";

import { MaskIcon } from "@/components/icon/MaskIcon.tsx";
import { getResourceIconClass, getResourceTypeName, type ResourceType } from "@/modules/api/resourceTypes.tsx";
import { cn } from "@/utils/classNames.ts";
import type { ReactNode } from "react";

export function ResourceWithIcon({ type, title }: { type: ResourceType; title?: ReactNode }) {
    return (
        <DetailWithIcon
            title={title ? title : getResourceTypeName(type)}
            icon={<MaskIcon className={cn("size-0.75rem text-primary", getResourceIconClass(type))} />}
        />
    );
}

export function DetailWithIcon({ title, icon }: { title: ReactNode; icon: ReactNode }) {
    return (
        <div className="flex items-center gap-0.375em">
            <div className={TC.Icon}>{icon}</div>
            <div>{title}</div>
        </div>
    );
}
